/**
 * This custom error class allows the API to send an InvalidInputException exception with details.
 */
export class ErrorWithDetails extends Error {
  details: string[];

  constructor(message: string, details: string[]) {
    super(message);
    this.details = details;
  }
}

export const ErrorWithDetailsHeader = [
  {
      header: "Error Message",
      cell: (item: string) => item
  }
];
